module.exports = __webpack_public_path__ + "static/payment_function-66f781cab9f4f959bf0e234a13997b6d.png";